export const sxForm = (theme = {}) => ({
  formStyle: {
    width: '100%',
    padding: { xs: '30px', sm: '10px 30px' },
    borderRadius: '15px',
    backgroundColor: '#FFFFFF',
  },
  sendButton: {
    width: '90%',
    height: { xs: '40px', sm: '50px' },
    fontSize: { xs: '14px', sm: '14px' },
    backgroundColor: theme.primary,
    color: theme.text1,
    border: `1px solid ${theme.primary}`,
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.primary,
      color: theme.text1,
      boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
    },
    marginBottom: '4px',
  },
  legalContainer: {
    padding: '20px',
    background: '#D9D9D9',
    borderRadius: '8px',
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  legalTitle: {
    color: 'black',
    fontWeight: 'bold',
    marginBottom: { xs: '6px', sm: '10px' },
    fontSize: { xs: '16px', sm: 'initial' },
  },
  legalText: {
    color: '#000',
    fontSize: '12px',
  },
});
